export class ScrChecker {
  constructor() {
    this.inviewElems = []; //inviewで効果をつける要素を登録する
  }
  setProps(el, props) {
    for (let key in props) {
      el.style.setProperty("--" + key, props[key]);
    }
  }
  clamp(v, min, max) {
    return min > v ? min : max < v ? max : v;
  }
  round(n) {
    return Math.round(n * 10000) / 10000;
  }

  calcElementOffsetY(elem) {
    let container = window;

    let parentElem;
    if (elem.parentElement) {
      parentElem = elem.parentElement;
    }
    let target = parentElem;

    // ページ全体に対するY座標を計算
    let numY = 0;
    do {
      numY += target.offsetTop; //target.offsetTop;はノードの上端に対しての現在の要素の距離
      target = target.offsetParent;
      //console.log(target);
    } while (target && target !== container); //要素のcontainerに対するY座標

    return numY;
  }

  onUpdate() {
    //ウインドウ情報 ie11未対応
    //let windowWidth = window.innerWidth;
    //let windowHeight = window.innerHeight;
    //let windowOffsetY = window.scrollY;

    //ウインドウ情報など ie11対応
    let windowLeft = window.screenLeft || window.screenX || 0;
    let windowTop = window.screenTop || window.screenY || 0;
    let windowWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    let windowHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    let windowScrollY = window.scrollY || window.pageYOffset;
    let windowScrollX = window.scrollX || window.pageXOffset;

    //console.log(windowScrollY);
    this.body = document.getElementsByTagName("body")[0];
    this.html = document.getElementsByTagName("html")[0];

    if (windowScrollY > windowHeight) {
      this.body.classList.add("scrolled-windowheight");
    } else {
      this.body.classList.remove("scrolled-windowheight");
    }

    if (windowScrollY > windowHeight * 0.8) {
      this.body.classList.add("scrolled-show-index-pager");
    } else {
      this.body.classList.remove("scrolled-show-index-pager");
    }

    if (this.body.classList.contains("index")) {
      //this.body.classList.remove('scrolled-title');
    } else {
      if (windowScrollY > 200) {
        this.body.classList.add("scrolled-title");
      } else {
        this.body.classList.remove("scrolled-title");
      }
    }

    // ===========
    // inview判定

    //.js-inview に .inview 追加
    if (this.inviewElems.length !== 0 && this.body.classList.contains("opening-finished")) {
      //inviewElems = document.querySelectorAll('.js-inview');//複数
      [].forEach.call(this.inviewElems, (elem) => {
        //console.log(elem.classList);
        let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
        let y = clientRect.top; //画面の上端から、要素の上端までの距離
        //let elemY = window.pageYOffset + clientRect.top;// ページの上端から、要素の上端までの距離

        //表示タイミング ウインドウ上端から
        let showPos = windowHeight * 0.6;
        if (windowWidth > 600) {
          showPos = windowHeight * 0.6; //pc
        }

        if (showPos > y) {
          if (this.body.classList.contains("loaded")) {
            elem.classList.add("inview");
            // let timerInviewAfter = setTimeout( () => {
            //     elem.classList.add('inview');
            // }, 1000);
          } else {
            elem.classList.add("inview");
          }
        }
      });
    }

    // ===========
    // JSでの表示位置調整
    // if (this.rotateHeadingElems !== 0) {
    //     [].forEach.call(this.rotateHeadingElems, (elem, index) => {
    //         let calcp, imageHeightView, skewHeight = 0;

    //         if (windowWidth > 735) {
    //             //画像全体は1000:377.5
    //             imageHeightView = windowWidth * (0.3775 - 0.16);
    //             skewHeight = windowWidth * 0.16; //斜め線は1000:1600
    //             calcp = 0.5 * (imageHeightView - elem.clientHeight) + 12;
    //         } else {
    //             //画像全体は750:428 = 0.57066
    //             imageHeightView = windowWidth * (0.57066 - 0.24);
    //             skewHeight = windowWidth * 0.24; //斜め線は1000:240
    //             calcp = 0.5 * (imageHeightView - elem.clientHeight) + 8;
    //             if (index != 1) {
    //                 calcp = 0.5 * (imageHeightView - elem.clientHeight) + 6;
    //             }
    //         }

    //         let props = {
    //             'trans-y': calcp,
    //         }

    //         this.setProps(elem, props);
    //         //console.log(imageHeightView + ', titleH=' + elem.clientHeight);
    //     });
    // }

    // ===========
    // SIDE PAGER 切り替え
    // if (document.getElementById('index-side-pager')) {
    //     // 全体
    //     let sidePos = document.getElementById('index-side-pager');

    //     // 丸
    //     let bullets = sidePos.querySelectorAll('.line .bullet-container .bullet');

    //     // 切り替え基準
    //     let checkSectionsId = ['index-news', 'index-about', 'index-member', 'index-product', 'index-contact'];

    //     // 丸リセット
    //     let nowState = 0;
    //     [].forEach.call(bullets, (elem) => {
    //         elem.classList.remove('selected');
    //     });

    //     // 切り替え実行 1
    //     [].forEach.call(checkSectionsId, (id) => {
    //         let elem = document.getElementById(id);
    //         let clientRect = elem.getBoundingClientRect(); // 要素の位置座標
    //         let y = clientRect.top; //画面の上端から、要素の上端までの距離

    //         //切り替えタイミング ウインドウ上端から
    //         let showPos = windowHeight * 0.2;
    //         if (windowWidth > 600) {
    //             showPos = windowHeight * 0.3; //pc
    //         }

    //         //何番目を表示するか
    //         if (y < showPos) {
    //             nowState += 1;
    //         }
    //     });

    //     if (nowState == 0 || nowState == 2 || nowState == 3 || nowState == 4) {
    //         sidePos.classList.add('white');
    //     } else {
    //         sidePos.classList.remove('white');
    //     }

    //     // 丸 切り替え
    //     [].forEach.call(bullets, (elem, index) => {
    //         if ((nowState - 1) == index) {
    //             elem.classList.add('selected');
    //         }
    //     });

    // }
  }

  // 初期化
  init() {
    this.inviewElems = document.querySelectorAll(".js-inview"); //複数
    //this.rotateHeadingElems = document.querySelectorAll('.js-pos-on-skewimg'); //複数
    //this.parallaxSections = document.querySelectorAll('.parallax-section');
  }
}
